import React, { useEffect, useState } from "react";
import {
  ToggleButton,
  ToggleButtonGroup,
  Grid,
  Box,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import GridViewIcon from "@mui/icons-material/GridView";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Link from "@mui/material/Link";
import { useIRGrade } from "./hooks";
import { IRGradingCard } from "../../components/irGrading/Card";
import { NoGrades } from "../../components/irGrading/NoGrades";
import { toast } from "react-toastify";
import TableRowsIcon from "@mui/icons-material/TableRows";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import { uploadJson } from "../../store/IRGrading/IRGradingBaseApi";
import Loader from "../../components/Loader";
import { getAllWithoutPage } from "../../store/course/courseBaseApi";
import { useCourse } from "../course/hooks";
import { json_files } from "../../utils";

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  padding: theme.spacing(1),
  height: "30px",
  border: "none",
  "&.Mui-selected": {
    background: "transparent",
    "& .MuiSvgIcon-root": {
      color: "var(--mui-palette-primary-orange)",
    },
  },
}));

export const IRGrading = () => {
  const navigate = useNavigate();
  const { loadGradeMap, gradingList, loading } = useIRGrade();
  const { loadCoursesList, diagnosticList, lastPage } = useCourse();
  const theme = useTheme();
  const [view, setView] = useState("card");
  const [grades, setGrades] = useState();

  useEffect(() => {
    loadCoursesList({ pageSize: 50, category: "Diagnostic" });
  }, []);

  // useEffect(() => {
  //     const fetchCourses = async () => {
  //         let page = 0;
  //         let hasMore = true;
  //         while (hasMore) {
  //             await loadCoursesList({ pageNo: page, category: "Diagnostic" });
  //             if (lastPage?.Diagnostic === true) {
  //                 hasMore = false;
  //             } else if (lastPage?.Diagnostic === false) {
  //                 page += 1;
  //                 await new Promise(resolve => setTimeout(resolve, 500)); // Prevent rapid API calls
  //             }
  //         }
  //     };

  //     fetchCourses();
  // }, []);

  const getCourseName = (courseId) => {
    const course = diagnosticList?.find((course) => course?.id === courseId);
    return course?.courseName;
  };

  useEffect(() => {
    loadGradeMap();
  }, []);

  // useEffect(() => {
  //     setGrades(grades)
  // }, [grades])

  useEffect(() => {
    setGrades(gradingList);
  }, [gradingList]);

  const deleteGrade = async (id) => {
    if (!confirm("Are you sure to delete this grading?")) {
      return;
    }
    const sendData = grades?.filter((grade) => grade?.irGradingId !== id);
    const json = JSON.stringify(sendData, null, 2);
    const blob = new Blob([json], { type: "application/json" });
    const formData = new FormData();
    formData.append("file", blob, json_files.gradingModels.name);
    try {
      const resp = await uploadJson({ id: null, formData });
      if (resp.message) {
        toast.success("Grading Deleted Successfully", "success");
        localStorage.setItem("irLevelMapping", resp.data);
        loadGradeMap();
        setGrades(sendData);
        // setTimeout(() => {
        //     window.location.reload()
        // }, 3000);
      }
    } catch (e) {
      return toast(e.error, "error");
    }
  };

  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      setView(newView);
    }
  };

  const columns = [
    {
      field: "courseId",
      headerName: "Diagnostic Test Name",
      flex: 1,
      renderCell: (params) => {
        return getCourseName(params?.row?.courseId);
      },
    },
    {
      field: "applicableGrades",
      headerName: "Applicable Grades",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const grades = params?.row?.applicableGrades || [];
        // Combine the grade names into a single string
        return grades?.map((grade) => grade?.grade).join(", ") || "N/A";
      },
    },
    {
      field: "studentType",
      headerName: "Student Type",
      flex: 0.6,
      sortable: false,
      renderCell: (params) => {
        const val = (params?.row?.studentType || "URBAN").toUpperCase();
        return val.charAt(0) + val.slice(1).toLowerCase();
      },
    },
    {
      field: "diagnosticTwo",
      headerName: "Diagnostic Test - 2",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const grades = params?.row?.diagnosticTwo || [];
        // Combine the grade names into a single string
        return (
          grades?.map((grade) => getCourseName(grade?.courseId)).join(", ") ||
          "N/A"
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      renderCell: (params) => {
        const grade = params?.row;
        const editLink = `ir-grading/edit/${grade?.id}`;
        return (
          <Box>
            <Link
              style={styles.actionBtnItem}
              href={editLink}
              title="Edit Grading"
            >
              <CreateIcon
                style={{
                  color: "var(--mui-palette-primary-button)",
                  fontSize: "1.2rem",
                }}
              />
            </Link>
            <Link
              style={styles.actionBtnItem}
              onClick={() => deleteGrade(grade?.id)}
              title="Delete Grading"
            >
              <DeleteIcon
                style={{
                  color: "var(--mui-palette-error-main)",
                  fontSize: "1.2rem",
                }}
              />
            </Link>
          </Box>
        );
      },
    },
  ];

  const rows = grades?.map((grade) => ({
    id: grade?.irGradingId,
    courseId: grade?.diagnosticOne?.courseId,
    applicableGrades: grade?.diagnosticOne?.applicableGrades,
    studentType: grade?.studentType || "URBAN",
    diagnosticTwo: grade?.diagnosticTwo,
  }));

  return (
    <>
      {" "}
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="course">
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography
                align="left"
                variant="h1"
                color="primary.blue"
                sx={{
                  margin: "0",
                  fontWeight: "700",
                  lineHeight: "1.5",
                  fontSize: "1.8rem",
                }}
              >
                Diagnostic Test Configuration
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  [theme.breakpoints.down("sm")]: {
                    flexDirection: "row",
                  },
                }}
              >
                <ToggleButtonGroup
                  style={styles.toggleButtonContainer}
                  sx={{
                    [theme.breakpoints.down("sm")]: {
                      justifyContent: "flex-start",
                    },
                  }}
                  value={view}
                  exclusive
                  onChange={handleViewChange}
                  aria-label="course view"
                >
                  <StyledToggleButton
                    value="list"
                    aria-label="list view"
                    title="List View"
                    sx={{
                      padding: "5px",
                      [theme.breakpoints.down("sm")]: {
                        fontSize: "0.7rem",
                      },
                    }}
                  >
                    <TableRowsIcon />
                  </StyledToggleButton>
                  <StyledToggleButton
                    value="card"
                    aria-label="card view"
                    title="Card View"
                    sx={{
                      padding: "5px",
                      [theme.breakpoints.down("sm")]: {
                        fontSize: "0.7rem",
                      },
                    }}
                  >
                    <GridViewIcon />
                  </StyledToggleButton>
                </ToggleButtonGroup>
                <div style={styles.create}>
                  <Link
                    component="button"
                    variant="body2"
                    onClick={() => navigate("/ir-grading/create")}
                    title="Create Ir Grading"
                    sx={{
                      background: "tranaparent",
                      color: "var(--mui-palette-primary-button)",
                      p: 0,
                    }}
                  >
                    <AddCircleIcon
                      sx={{ fontSize: "1.8rem", marginTop: "4px" }}
                    />
                  </Link>
                </div>
              </Box>
            </Box>
          </div>
          {/* <Link
                    component="button"
                    variant="body2"
                    onClick={() => navigate('/ir-grading/edit/Grade 2')}
                    title='Create Grades'
                    sx={{
                        background: 'tranaparent',
                        color: 'var(--mui-palette-primary-button)',
                        p: 0,
                    }}
                >edit </Link>
                <br />
                <button onClick={deleteDrade}> Delete</button> */}

          <Box
            sx={{
              clear: "both",
              width: "100%",
              float: "left",
              pt: 3,
              pb: 3,
              position: "relative",
              boxSizing: "border-box",
            }}
          >
            {view === "card" ? (
              <Grid
                container
                sx={{
                  position: "relative",
                  zIndex: 1,
                  marginLeft: "-8px",
                  marginRight: "-8px",
                  width: "auto",
                }}
              >
                {grades?.length > 0 ? (
                  grades?.map((grade, id) => (
                    <Grid
                      item
                      key={grade.gradeId}
                      xs={12}
                      sm={6}
                      md={4}
                      lg={3}
                      sx={{ p: 1 }}
                    >
                      <IRGradingCard
                        grade={grade}
                        id={grade.irGradingId}
                        deleteGrade={deleteGrade}
                      />
                    </Grid>
                  ))
                ) : (
                  <NoGrades />
                )}
              </Grid>
            ) : (
              <div style={{ minHeight: 400, width: "100%", overflow: "auto" }}>
                {grades?.length > 0 ? (
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    sx={{
                      backgroundColor: "var(--mui-palette-common-white)",
                      [theme.breakpoints.down("sm")]: {
                        width: "900px",
                      },
                      "& .css-yrdy0g-MuiDataGrid-columnHeaderRow": {
                        background:
                          "var(--mui-palette-primary-blue) !important",
                        color: "var(--mui-palette-action-active)",
                      },
                      "& .MuiDataGrid-columnHeader": {
                        background:
                          "var(--mui-palette-primary-blue) !important",
                        color: "var(--mui-palette-common-white)",
                        "&:focus": {
                          outline: "none",
                        },
                      },
                      "& .MuiDataGrid-columnHeaderTitle": {
                        fontSize: "14px",
                        fontWeight: "bold",
                      },
                      "& .MuiSvgIcon-root": {
                        color: "var(--mui-palette-common-white)",
                      },
                    }}
                    pageSize={5}
                  />
                ) : (
                  <NoGrades />
                )}
              </div>
            )}
          </Box>
          <Typography
            align="left"
            variant="h1"
            color="primary.blue"
            sx={{
              margin: "0",
              fontWeight: "700",
              lineHeight: "1.5",
              fontSize: "1.8rem",
            }}
          >
            Course Assignments
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              background: "var(--mui-palette-primary-blue)",
              alignItems: "center",
              p: 2,
              mt: 2,
              borderRadius: "10px",
              color: "#fff",
            }}
          >
            Course Mapping
            <div style={styles.actionBtn}>
              <Link
                style={styles.assessmentsLink}
                href={`course-mapping`}
                title="Edit mapping"
              >
                {" "}
                <CreateIcon
                  sx={{
                    color: "var(--mui-palette-primary-contrastText)",
                    fontSize: "1.2rem",
                  }}
                />
              </Link>
            </div>
          </Box>
        </div>
      )}
    </>
  );
};

const styles = {
  toggleButtonContainer: {
    display: "flex",
    justifyContent: "center",
  },
  create: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "5px",
  },
  courses: {
    marginTop: "2rem",
  },
  label: {
    color: "var(--mui-palette-common-black)",
    fontWeight: "bold",
  },
  inputLabel: {
    color: "var(--mui-palette-primary-darkGrey)",
    marginBottom: "5px",
    fontWeight: "600",
    fontSize: "14px",
  },
  gridContainer: {
    mt: 2,
  },
  suggestionBox: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    marginTop: "10px",
  },
  suggestionItem: {
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "2px",
    cursor: "pointer",
    boxShadow: "0 4px 8px var(--mui-palette-secondary-boxShadow1)",
    backgroundColor: "var(--mui-palette-gray-lightGrey300)",
  },
  uploadBtn: {
    width: "50px",
    height: "50px",
    borderRadius: "5px",
  },
  hiddenInput: {
    display: "none",
  },
  actionBtnItem: {
    marginLeft: "5px",
    marginRight: "5px",
    cursor: "pointer",
  },
};
